<div
  class="w-full flex flex-col gap-4 p-4 mt-4 bg-white rounded shadow-sm border border-gray-100 animate-pulse"
>
  <!-- Table header skeleton -->
  <div class="flex gap-4 border-b pb-4 mb-2">
    <div class="h-6 bg-gray-200 rounded w-1/3"></div>
    <div class="h-6 bg-gray-200 rounded w-1/6"></div>
    <div class="h-6 bg-gray-200 rounded w-1/6"></div>
    <div class="h-6 bg-gray-200 rounded w-1/6"></div>
    <div class="h-6 bg-gray-200 rounded w-1/6"></div>
  </div>

  <!-- Rows skeleton -->
  <div class="flex gap-4 items-center py-2" *ngFor="let i of getRowsArray()">
    <div class="h-4 bg-gray-200 rounded w-1/3"></div>
    <div class="h-4 bg-gray-200 rounded w-1/6"></div>
    <div class="h-4 bg-gray-200 rounded w-1/6"></div>
    <div class="h-4 bg-gray-200 rounded w-1/6"></div>
    <div class="h-4 bg-gray-200 rounded w-1/6"></div>
  </div>
</div>
